import { forwardRef } from 'react';
import type React from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const PlugIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      ref={ref}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4L5 1.01042C5 0.74244 5.10536 0.485437 5.29289 0.295946C5.48043 0.106456 5.73478 0 6 0C6.26522 0 6.51957 0.106456 6.70711 0.295946C6.89464 0.485437 7 0.74244 7 1.01042L7 4H9V1.01042C9 0.74244 9.10536 0.485437 9.29289 0.295946C9.48043 0.106456 9.73478 0 10 0C10.2652 0 10.5196 0.106456 10.7071 0.295946C10.8946 0.485437 11 0.74244 11 1.01042V4H11.8715C12.1671 4.0018 12.4502 4.12261 12.6592 4.33625C12.8683 4.54989 12.9865 4.83913 12.9883 5.14125L12.9861 7.63375C13.0196 8.09177 13.0657 9.50083 12.1626 10.8544C11.6961 11.5387 11.0712 12.0947 10.3436 12.4727C9.89287 12.7053 9.43899 12.8468 9 12.9239V14.9896C9 15.2576 8.89464 15.5146 8.70711 15.7041C8.51957 15.8935 8.26522 16 8 16C7.73478 16 7.48043 15.8935 7.29289 15.7041C7.10536 15.5146 7 15.2576 7 14.9896V12.8923C6.30544 12.7596 5.80118 12.543 5.6432 12.4727C4.01186 11.6099 3.13402 10.1978 3 8.30176V5.14125C3.00176 4.83913 3.11999 4.54989 3.32906 4.33625C3.53813 4.12261 3.82118 4.0018 4.11684 4H5Z"
        fill="#183558"
      />
    </svg>
  );
});

export default PlugIcon;
